function fixFooterPadder() {
    var bodyWrapper = jQuery('.outer-wrapper');
    var footer = jQuery('footer.footer');

    bodyWrapper.css('padding-bottom', footer.outerHeight() + 'px');

    if (jQuery('#wpadminbar').length) {
        jQuery('html').attr('style', 'margin: 0 !important;');
        jQuery('body').css('padding-top', '32px');
    }
}

(function ($) {
    $(document).ready(fixFooterPadder);
    $(window).ready(fixFooterPadder);
    $(window).on('load', fixFooterPadder);
    $(window).resize(fixFooterPadder);
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/sticky-footer.js